import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    NgControl,
    ValidationErrors,
} from '@angular/forms';

import { FormControlComponent } from '../../../abstracts/form-control.abstract';
import { IPasswordInputConfig } from '../../../interfaces/password-input-config.interface';
import { PasswordValidators } from '../../../validators/password-equality-check.validator';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PasswordComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: PasswordComponent,
        },
    ],
})
export class PasswordComponent extends FormControlComponent implements OnInit {
    @Output() public elementSizeModification = new EventEmitter<void>();

    public oldPwdInputConfig: IPasswordInputConfig = {
        inputId: 'oldPassword',
        placeholder: 'MY_ACCOUNT.OLD_PASSWORD',
    };

    public newPwdInputConfig: IPasswordInputConfig = {
        inputId: 'password',
        placeholder: 'MY_ACCOUNT.NEW_PASSWORD',
    };

    public newPwdConfirmInputConfig: IPasswordInputConfig = {
        inputId: 'passwordConfirm',
        placeholder: 'MY_ACCOUNT.CONFIRM_NEW_PASSWORD',
    };

    public newPwdForm: FormGroup;
    public ngControl: NgControl;

    constructor(private builder: FormBuilder, private inj: Injector) {
        super();
    }

    ngOnInit(): void {
        this.ngControl = this.inj.get(NgControl);
        this.ngControl.control.markAllAsTouched = () => {
            this.newPwdForm.markAllAsTouched();
        };
        this.newPwdForm = this.builder.group(
            {
                passwords: this.builder.group(
                    {
                        password: ['', [PasswordValidators.passwordFormatValidator()]],
                        passwordConfirm: ['', [PasswordValidators.passwordFormatValidator()]],
                    },
                    {
                        validators: [PasswordValidators.passwordMatchValidator()],
                    }
                ),
                oldPassword: [''],
            },
            {
                validators: [PasswordValidators.allPasswordPresentValidator()],
            }
        );
    }

    public validate(): ValidationErrors | null {
        return this.newPwdForm.invalid
            ? this.newPwdForm.errors || this.oldPassword.errors || this.newPwd.errors || this.newPwdConfirm.errors
            : null;
    }

    public writeValue(value: any): void {
        if (value) {
            this.value = value;
            this.newPwdForm.patchValue(value, { emitEvent: false });
        }
    }

    public onInput(): void {
        if (this.disabled) {
            return;
        }

        this.value = this.newPwdForm.value;

        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public get newPwd(): FormControl {
        return this.newPwdForm.get('passwords.password') as FormControl;
    }

    public get newPwdConfirm(): FormControl {
        return this.newPwdForm.get('passwords.passwordConfirm') as FormControl;
    }

    public get oldPassword(): FormControl {
        return this.newPwdForm.get('oldPassword') as FormControl;
    }
}
